<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            dataValueFormatFilter="currency"
            :main_icon="main_icon"
            :icons="icons"
            :load_url="load_url"
            :title="title"
            :under_title="under_title">
    </DashboardCard>
</template>



<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'CurrentSettledGoods',
        components: {DashboardCard},
        props: {
            width: {type:Number, default: 25},
            dataDisplay: {type:String, default: null},
        },
        data() {
            var labels = [];
            return {
                main_icon: 'fa-light fa-money-bill-alt',
                title: 'Current Value of Settled Goods',
                under_title: null,
                load_url: '/dashboards/CurrentSettledGoods',
                icons: labels,
            };
        },
    };
</script>

<style scoped>

</style>